import React from "react";

const InfoIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="50"
            height="50"
            viewBox="0 0 50 50"
            {...props}
        >
            <defs style={{ pointerEvents: "none" }}>
                <clipPath id="clip-path" style={{ pointerEvents: "none" }}>
                    <rect
                        id="Rechteck_3"
                        data-name="Rechteck 3"
                        width="50"
                        height="50"
                        transform="translate(0 0)"
                        fill="none"
                        style={{ pointerEvents: "none" }}
                    />
                </clipPath>
            </defs>
            <g
                id="Gruppe_4"
                data-name="Gruppe 4"
                transform="translate(0 0)"
                style={{ pointerEvents: "none" }}
            >
                <path
                    style={{ pointerEvents: "none" }}
                    id="Pfad_9"
                    className="icon-fill"
                    data-name="Pfad 9"
                    d="M27.919,17.166h-5.9V12.7h5.9ZM27.847,37H22.123V20.118h5.724Z"
                    fill="#e60028"
                />
                <g
                    id="Gruppe_2"
                    data-name="Gruppe 2"
                    style={{ pointerEvents: "none" }}
                >
                    <g
                        style={{ pointerEvents: "none" }}
                        id="Gruppe_1"
                        data-name="Gruppe 1"
                        clipPath="url(#clip-path)"
                    >
                        <path
                            style={{ pointerEvents: "none" }}
                            id="Pfad_10"
                            className="icon-fill"
                            data-name="Pfad 10"
                            d="M25,50A25,25,0,1,1,50,25,25.028,25.028,0,0,1,25,50M25,4A21,21,0,1,0,46,25,21.023,21.023,0,0,0,25,4"
                            fill="#e60028"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default InfoIcon;
